var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 23C6.24632 23 6.75 22.4963 6.75 21.875C6.75 21.2537 6.24632 20.75 5.625 20.75C5.00368 20.75 4.5 21.2537 4.5 21.875C4.5 22.4963 5.00368 23 5.625 23Z",
    fill: "#1650FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.375C8.87132 20.375 9.375 19.8713 9.375 19.25C9.375 18.6287 8.87132 18.125 8.25 18.125C7.62868 18.125 7.125 18.6287 7.125 19.25C7.125 19.8713 7.62868 20.375 8.25 20.375Z",
    fill: "#1650FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 20C3.24632 20 3.75 19.4963 3.75 18.875C3.75 18.2537 3.24632 17.75 2.625 17.75C2.00368 17.75 1.5 18.2537 1.5 18.875C1.5 19.4963 2.00368 20 2.625 20Z",
    fill: "#1650FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 17.375C5.87132 17.375 6.375 16.8713 6.375 16.25C6.375 15.6287 5.87132 15.125 5.25 15.125C4.62868 15.125 4.125 15.6287 4.125 16.25C4.125 16.8713 4.62868 17.375 5.25 17.375Z",
    fill: "#1650FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2498 4.25H20.5592C20.4618 4.24966 20.3653 4.26853 20.2752 4.30553C20.1851 4.34253 20.1032 4.39694 20.0342 4.46563L17.2498 7.25L5.18421 9.25626C5.04762 9.27886 4.91995 9.33882 4.81534 9.42952C4.71073 9.52021 4.63327 9.63809 4.59153 9.77009C4.5498 9.9021 4.54541 10.0431 4.57887 10.1774C4.61232 10.3118 4.68231 10.4342 4.78108 10.5313L13.9686 19.7188C14.0656 19.8175 14.1881 19.8875 14.3224 19.921C14.4568 19.9544 14.5977 19.95 14.7297 19.9083C14.8618 19.8666 14.9796 19.7891 15.0703 19.6845C15.161 19.5799 15.221 19.4522 15.2436 19.3156L17.2498 7.25",
    stroke: "#1650FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShower);
export default __webpack_public_path__ + "static/media/iconShower.a16ede1b5a313fdd409a86dcb899296d.svg";
export { ForwardRef as ReactComponent };